import { DatatableEntity } from "./datatable-entity"

export abstract class ApplicationEntity extends DatatableEntity {
  public id?: number

  constructor(id?: number) {
    super()
    this.id = id
  }
}
